import axios from "axios";
import router from '../router';
import Vue from 'vue';
import ElementLocale from 'element-ui/lib/locale';
import { MENUTYPE, VENDINGTYPE } from '../app/common/resources/resources.js';
import store from '../store'
import environment from "../environment"

//#region 频繁请求限制
let urlPool = new Map();
function requestLimit(url) {
  return new Promise(async (resolve) => {
    //无相同接口
    if (!urlPool.has(url)) {
      urlPool.set(url, {
        id: setTimeout(() => {
          urlPool.delete(url);
        }, 100)
        , resolve: null
      });
      resolve(1);
      return;
    }
    //有相同接口
    const poolData = urlPool.get(url);
    clearTimeout(poolData.id);
    if (poolData.resolve !== null) poolData.resolve(-1);
    urlPool.set(url, {
      id: setTimeout(() => {
        resolve(1);
        urlPool.delete(url);
      }, 500)
      , resolve
    });
  });
}
//#endregion

//#region 筛选特殊字符
const stringRegex =
  /(--|#|;|')|(\bSELECT\b|\bUPDATE\b|\bDELETE\b|\bINSERT\b|\bDROP\b)/gi;
function stringFiltering(params = "") {
  if (typeof params != "string") return false;
  return stringRegex.test(params);
}
//#endregion

function areaBaseUrlHandle(url = "") {
  if (environment.AREA_SIGN === "test") {
    if (url.includes("25:20004") || !url.includes("24:20004")) return url;
    switch (store.getters["area"]) {
      case 1: return url;
      case 2: return url.replace(/24:20004/gi, "26:20004");
      default: return url;
    }
  } else if (environment.AREA_SIGN === "outer") {
    if (url.includes("user0") || !url.includes("user1")) return url;
    return url.replace(/user1/gi, `user${store.getters["area"]}`);
  }
}
function post(url, params, hearder, options) {
  if (params) {
    params.systemid = MENUTYPE.LANDLORD;
    params.vendingtype = VENDINGTYPE.PC;
  }
  return new Promise(async (resolve, reject) => {
    // 频繁请求
    const limitId = await requestLimit(url);
    if (limitId !== 1) return reject("请勿频繁请求");
    // 敏感字符
    if (stringFiltering(JSON.stringify(params))) return reject("包含敏感字符");
    axios.post(areaBaseUrlHandle(url), params, hearder).then(res => {
      // console.log(res.data);
      if (res.data.success == 6 || res.code == 401) {
        goLogin();
      } else {
        successCheck(res.data, params)
        if (options && options.origin === true) { // 获取原始数据
          resolve(res)
        } else {
          resolve(res.data);
        }
      }
    }).catch(err => {
      // console.log('posterr>> ', err)
      if (process.env.NODE_ENV !== 'development') {
        robotAlarm(err);
      }
      reject(errorHandle(err?.data));
    });
  })
}

function get(url, params, hearder) {
  return new Promise(async (resolve, reject) => {
    const limitId = await requestLimit(url);
    if (limitId !== 1) return reject("请勿频繁请求");
    const requestUrl = getUrlHandle(url, params);
    if (stringFiltering(requestUrl)) return reject("包含敏感字符");
    try {
      let res = await axios.get(requestUrl, hearder);
      if (res.success === undefined && res.data !== undefined) {
        if (res.code == 401) {
          goLogin();
          resolve({});
          return;
        }
        res = res.data;
      }
      if (res.success === 6 || res.code === 401) {
        goLogin();
        resolve({});
        return;
      }
      successCheck(res, params)
      resolve(res);
    } catch (e) {
      reject(errorHandle(e?.data));
    }
  })
}

function exportPost(url, params, hearder) {
  let downloadUrl = urlHandleExport(areaBaseUrlHandle(url));
  return new Promise(async (resolve, reject) => {
    const limitId = await requestLimit(url);
    if (limitId !== 1) return reject("请勿频繁请求");
    if (stringFiltering(JSON.stringify(params))) return reject("包含敏感字符");
    axios.post(downloadUrl, params, hearder).then(res => {
      if (res.data.success == 6 || res.code == 401) {
        goLogin();
      } else {
        successCheck(res.data, params)
        resolve(res.data);
      }
    }).catch(err => {
      reject(errorHandle(err?.data));
    });
  })
}
// url处理 传入 查询接口地址,返回 导出接口地址
function urlHandle(url) {
  let [httpStr, baseUrl] = url.split('//');
  let baseUrlArr = baseUrl.split('/');
  let index = baseUrlArr.findIndex(item => item == 'service');
  baseUrlArr.splice(index + 1, 0, 'download')
  let downloadUrl = baseUrlArr.join('/');
  return httpStr + '//' + downloadUrl;

}
// url处理 传入 查询接口地址,返回 导出接口地址
function urlHandleExport(url) {
  let [httpStr, baseUrl] = url.split('//');
  let baseUrlArr = baseUrl.split('/');
  let index = baseUrlArr.findIndex(item => item == 'service');
  baseUrlArr.splice(index + 1, 0, 'export')
  let downloadUrl = baseUrlArr.join('/');
  return httpStr + '//' + downloadUrl;

}
//默认网络请求(通过success == 1判断)错误时,提示后端返回的错误信息;
//网络请求参数带successCheckType时,不做处理与提示,由具体页面自己处理
function successCheck(res, params) {
  if (params === undefined || params === null || params === '' || params.successCheckType === undefined) {
    if (res.success != undefined && res.success != 1) {
      let errordetail = res.errordetail || res.errmsg || res.error || res.message;
      Vue.prototype.$message({
        message: errordetail,
        type: 'error'
      });
    }
  }
}


function errorHandle(data) {
  if (!data) return;
  if (data.data) data = data.data;
  let { error, status, message, errordetail } = data;
  let ret = "";
  switch (status) {
    case 401:
      ret = "401 " + error;
      goLogin();
      break;
    case 404:
      ret = "404 " + error;
      break;
    case 500:
      ret = error;
      break;
    default:
      break;
  }
  console.log(">>>>>>什么鬼", data);
  Vue.prototype.$message({
    message: data.errordetail || data.errmsg || data.error || data.message,
    type: 'error'
  });
  return ret;
}


function goLogin() {
  console.log(router);
  if (router.history.current.name == "Login") {
    return
  }
  Vue.prototype.$loading().close();
  router.replace('/login');
  Vue.prototype.$message({
    message: ElementLocale.t('lang.logintimeout'),
    type: 'error'
  });
}


function robotAlarm(data) {
  if (!data) {
    return
  }
  console.log(data);
  let text = {
    "url": data.config.url + '\n',
    "HTTP_ACCESS_TOKEN": data.config.headers.HTTP_ACCESS_TOKEN + '\n',
    "Request": data.config.headers.data + '\n',
    "请求时间": ""
  }
  let params = {
    "at": {
      "atMobiles": [
      ],
      "atUserIds": [
      ],
      "isAtAll": false
    },
    "markdown": {
      "title": "异常",
      "text": `### Web异常 ${data.status} \n url:${data.config.url} \n HTTP_ACCESS_TOKEN:${data.config.headers.HTTP_ACCESS_TOKEN} \n\n Request:${data.config.data} \n`
    },
    "msgtype": "markdown"
  }
}

function getUrlHandle(baseUrl, params) {
  let url = areaBaseUrlHandle(baseUrl);
  if (params == undefined || params == null || Object.keys(params).length < 1) return url;
  url += "?";
  Object.keys(params).forEach(elem => {
    if (params[elem] == undefined) params[elem] = '';
    url = url + elem + "=" + params[elem] + "&";
  });
  return url.slice(0, url.length - 1);
}


export {
  post,
  get,
  exportPost
}